import { Button } from "@heroui/react";
import { Upload } from "@phosphor-icons/react";
import { memo } from "react";

interface Props {
  onClick: () => void;
}

const DueDiligenceUploadCellInner = ({ onClick }: Props) => {
  return (
    <Button
      onClick={onClick}
      className="bg-moss-primary/5 hover:bg-moss-primary/10 border-moss-primary/40 text-moss-primary flex h-auto w-full min-w-0 flex-col items-center gap-1 rounded-md border border-dashed px-3 py-2 transition-colors"
      aria-label="Upload document"
    >
      <Upload size={18} weight="bold" />
      <span className="text-xs font-semibold">Upload</span>
    </Button>
  );
};

export const DueDiligenceUploadCell = memo(DueDiligenceUploadCellInner);
